module.exports = __webpack_public_path__ + "assets/img/covers-sm.76ab2c80.jpg";